<template>
<v-container>
  <v-row dense>
    <v-col
      v-for="project in projects"
      :key="project.name"
      cols="12" sm="5"
    >
      <v-card>
        <v-img
          :src="getImageSrc(project)"
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,0) 70%, rgba(0,0,0,.8)"
          height="200px"
        >
          <v-card-title v-text="project.name"></v-card-title>
        </v-img>
        <v-card-subtitle class="pb-0">{{project.address}}</v-card-subtitle>
        <v-card-text class="text--primary">
          {{project.description}}
        </v-card-text>
        <v-card-actions>
          <v-btn class="ml-2" color="primary" @click="explore(project.id)">Explore</v-btn>
          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>mdi-heart-outline</v-icon>
          </v-btn>
<!--
          <v-btn icon>
            <v-icon>mdi-alert-circle-outline</v-icon>
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  computed: {
    projects () {
      return this.$store.getters['projects/items']
    }
  },
  data: () => ({
  }),
  created () {
    this.$store.dispatch('projects/list')
  },
  methods: {
    getImageSrc (project) {
      return `${project.config.assetsURL}/${this.$store.getters.env}${project.config.projectThumbnailURL}`
    },
    explore (id) {
      window.location.href = `uniwebview://firstvue-scene?id=${id}`
    }
  }
}
</script>

<style>
  .v-item-group.v-bottom-navigation .v-btn.v-size--default {
    height: inherit;
  }
</style>
